export const Name = /^[A-Za-z].{0,18}[A-Za-z]$/;
export const PhoneNumber = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
export const Mileage = /^[\d]*([\d]+,?[\d]+)*([\d][\d]*)?$/;
export const Currency = /^\$*[\d]*([\d]+,?[\d]+)*([\d]+\.?[\d]*)?$/;
export const Email = /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\.)+([A-Za-z]{2,4})$/;
export const ZipCode = /^(\d{5}-\d{4})|(\d{5})$/;
export const HasNumber = /\d/;
export const HasSpecialChar = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
//# sourceMappingURL=commonRegex.js.map